module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-book-62d5e3fbe5b4f6faf109c9bbf1b3f03d.png";